import React from "react";

const DIMENSIONS = [
    { key: "width", label: "Width" },
    { key: "height", label: "Height" },
    { key: "depth", label: "Depth" },
    { key: "armHeight", label: "Arm Height" },
    { key: "seatHeight", label: "Seat Height" },
    { key: "seatDepth", label: "Seat Depth" }
];

class DimensionsMenu extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.getInitialValues(props.values);
    }

    getInitialValues(values) {
        var s = {};
        DIMENSIONS.forEach(function (dim) {
            s[dim.key + "Min"] = (values && values[dim.key + "Min"]) || "";
            s[dim.key + "Max"] = (values && values[dim.key + "Max"]) || "";
        });
        return s;
    }

    componentDidUpdate(prevProps) {
        if (prevProps.values !== this.props.values) {
            this.setState(this.getInitialValues(this.props.values));
        }
    }

    handleChange = (field, value) => {
        // Allow only numbers and decimal points
        var cleaned = value.replace(/[^0-9.]/g, "");
        this.setState({ [field]: cleaned });
    };

    handleSubmit = () => {
        var dims = {};
        var hasValue = false;
        DIMENSIONS.forEach((dim) => {
            var minVal = this.state[dim.key + "Min"];
            var maxVal = this.state[dim.key + "Max"];
            if (minVal !== "") {
                dims[dim.key + "Min"] = parseFloat(minVal);
                hasValue = true;
            }
            if (maxVal !== "") {
                dims[dim.key + "Max"] = parseFloat(maxVal);
                hasValue = true;
            }
        });

        if (typeof this.props.onApply === "function") {
            this.props.onApply(hasValue ? dims : {});
        }
        if (typeof this.props.close === "function") {
            this.props.close();
        }
    };

    render() {
        return (
            <div className="ff-dimensions-menu">
                {DIMENSIONS.map((dim) => (
                    <div key={dim.key} className="ff-dimensions-row">
                        <span className="ff-dimensions-label">{dim.label}</span>
                        <input
                            type="text"
                            className="ff-dimensions-input"
                            placeholder="Min"
                            value={this.state[dim.key + "Min"]}
                            onChange={(e) => this.handleChange(dim.key + "Min", e.target.value)}
                        />
                        <span className="ff-dimensions-separator">&ndash;</span>
                        <input
                            type="text"
                            className="ff-dimensions-input"
                            placeholder="Max"
                            value={this.state[dim.key + "Max"]}
                            onChange={(e) => this.handleChange(dim.key + "Max", e.target.value)}
                        />
                    </div>
                ))}
                <button
                    type="button"
                    className="ff-dimensions-submit"
                    onClick={this.handleSubmit}
                >
                    Search By Dimension
                </button>
            </div>
        );
    }
}

export default DimensionsMenu;
